import "./index.less";
import * as React from "react";
import {
    AtmanAssessmentDocumentStructure,
    CompetencyGroupEnum,
    DimensionGroupStructure,
    DistributionData,
} from "@atman/business";
import { DimensionGroupScore } from "./components/DimensionGroupScore";

export interface IDimensionGroupScoreSummaryProps {
    assessmentDocuments: AtmanAssessmentDocumentStructure[];
    scores?: Dictionary<string, number> | undefined; // Scores for a single candidate
    distributionData?: DistributionData; // Scores for team distribution (currently unused)
}

export const DimensionGroupScoreSummary: React.FC<IDimensionGroupScoreSummaryProps> = (props) => {
    const { assessmentDocuments, scores, distributionData } = props;

    const filterGroups = (groups: DimensionGroupStructure[]) => {
        return groups.filter((g) => g.enumName !== CompetencyGroupEnum[CompetencyGroupEnum.Interests]); // Exclude these because they are not competencies.
    };

    return (
        <div className="DimensionGroupScoreSummary">
            <h5>{"psychometrics.competencies.groupResult.description".localize()}</h5>
            <div className="d-flex justify-content-center align-items-center">
                {assessmentDocuments.map((d) => {
                    const groups = filterGroups(d.groups);

                    return groups.map((g) => {
                        const width = 100 / groups.length;
                        const dimensionNames = g.dimensions.map((x) => x.enumName?.toCamel());

                        return (
                            <DimensionGroupScore
                                key={`${d.title}-${g.enumName}`}
                                title={g.name ? g.name : d.title}
                                dimensionNames={dimensionNames}
                                distributionData={distributionData}
                                scores={scores}
                                width={width}
                            />
                        );
                    });
                })}
            </div>
        </div>
    );
};
